import { MapPin, Truck } from "lucide-react";

const LOCAL = [
  { area: "Americas Region", detail: "Serving surrounding counties and major industrial corridors throughout North and South America" },
  { area: "Texas Statewide", detail: "State agencies, municipalities, school districts, and commercial buyers" },
  { area: "Africa & Europe Region", detail: "Serving key trade corridors and industrial hubs across the African continent and European markets" },
  { area: "Asia Region", detail: "Connecting key trade corridors and industrial hubs across Asia's manufacturing and logistics centers" },
];

export function ServiceAreas({ compact = false }) {
  return (
    <section data-testid="service-areas-section" className={`${compact ? "py-14" : "py-16 md:py-24"} bg-[var(--pg-bg)]`}>
      <div className="pg-container">
        <div className="max-w-3xl">
          <span className="eyebrow">Service Area</span>
          <h2 className="mt-4 text-[30px] md:text-[38px] font-extrabold leading-[1.1]">Houston, Texas-based. National and Worldwide delivery coordination.</h2>
          <p className="mt-4 text-[16px] text-[var(--pg-ink-soft)] leading-relaxed">
            Patrick Global is headquartered in Houston, Texas and works with purchasing departments, government
            agencies, prime contractors, and commercial operations across the United States and internationally. Where a
            requirement calls for it, we coordinate supplier shipments and freight to facilities and job sites in other
            states and overseas.
          </p>
        </div>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {LOCAL.map((l, i) => (
            <div key={l.area} data-testid={`service-area-${i}`} className="bg-white border border-slate-200 rounded-xl p-5">
              <MapPin size={20} className="text-[var(--pg-accent)]" />
              <h3 className="mt-3 font-[Poppins] font-bold text-[15.5px] text-[var(--pg-navy)]">{l.area}</h3>
              <p className="mt-1.5 text-[13.5px] text-[var(--pg-ink-soft)] leading-relaxed">{l.detail}</p>
            </div>
          ))}
        </div>
        <div className="mt-6 bg-white border border-slate-200 rounded-xl p-5 flex items-start gap-3" data-testid="service-area-national">
          <Truck size={20} className="text-[var(--pg-accent)] mt-0.5 flex-shrink-0" />
          <p className="text-[14px] text-[var(--pg-ink-soft)] leading-relaxed">
            <strong className="text-[var(--pg-navy)]">Global capability:</strong> supplier identification, quoting, and purchasing
            are handled from Houston; delivery is coordinated with suppliers and carriers to the destination you specify on your RFQ.
          </p>
        </div>
      </div>
    </section>
  );
}
